import * as React from "react"
import { Box, Chip } from "@mui/material";


export default function stockColumn(name, label, visibility) {
	return [{
		name: 'stock', label: 'Stock Status',
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? "In Stock" : "Out of Stock"
		}
	} , {
		name: 'stock', label: 'Stock',
		options: {
			filter: false,
			display: visibility,
			setCellHeaderProps: () => ({ sx: { minWidth: 60 }}),
			customBodyRowRender: value => (
				<Box sx={ {textAlign:'center'} }>
				  {value ? (
					<Chip sx={{ backgroundColor: "success.lighter"}} label={" "} />
				  ) : (
					<Chip sx={{ backgroundColor: "error.lighter"}}label={" "} />
				  )}
				</Box>
			)
		}
	}]
}
